import React from "react";
import PropTypes from "prop-types";
import styles from "./style/EarningCard.module.css";

const EarningCard = (props) => {
  const { content, money } = props;
  return (
    <div className={styles.earningCard}>
      <p>{content}</p>
      <h2>${money}</h2>
    </div>
  );
};

/* required: display name */
EarningCard.displayName = "EarningCard";

/* required: props types */
EarningCard.propTypes = { content: PropTypes.string, money: PropTypes.number };

/* required: default props */
EarningCard.defaultProps = { content: "", money: 0 };

export { EarningCard };
